import Link from 'next/link';
import { useState } from 'react';

import Card from 'app/components/common/Card';
import Container from 'app/components/common/Container';
import ArrowIcon from 'app/components/icons/ArrowIcon';
import { createMarkup } from 'app/scripts/utils';
import './faq.css';
import 'styles/faq.css';

export default function Faq({
  section,
  isFaq = false,
  forCSS = false,
  isDeleteRightData = false,
  isBenchFaq = false,
  isdevops = false,
  ishome = false,
  writetous,
}) {
  let faqlist = isFaq
    ? section?.faq_list?.map((list, key) => ({
        question: list?.question,
        answer: list?.answer,
        descriptionEditor: list?.descriptionEditor,
        key: key,
      }))
    : section?.faq_detail?.map((list, key) => ({
        question: list?.question,
        answer: list?.answer,
        descriptionEditor: list?.descriptionEditor,
        key: key,
      }));

  const [open, setOpen] = useState(0);

  const handleOpen = value => {
    setOpen(open === value ? 0 : value);
  };

  return (
    <Container className="faqs-sec">
      <div
        className={`${ishome ? '' : section?.image?.data?.attributes?.url ? 'md:pt-[45px] pt-[30px]' : ''}`}
      >
        {isdevops ? (
          section?.titleEditor && (
            <div
              className={`${writetous && 'text-[#383838] text-center'} font-[800] xl:text-[50px] md:text-[32px] text-[26px] title_hd leading-tight`}
              dangerouslySetInnerHTML={createMarkup(section?.titleEditor)}
            ></div>
          )
        ) : isFaq && isBenchFaq ? (
          <div className="">
            <h2 className="relative font-[800] xl:text-[50px] lg:text-[32px] text-[26px] text-center leading-tight">
              {section?.title}
            </h2>
          </div>
        ) : isFaq ? (
          <div className="text-center">
            <h2 className="font-[800] text-black xl:text-[50px] lg:text-[32px] text-[26px] text-center leading-tight">
              {section?.title}
            </h2>
          </div>
        ) : (
          <div className="text-center">
            {section?.h1_black && (
              <h2 className="font-[800] xl:text-[50px] md:text-[32px] text-[26px] title_hd leading-tight">
                {section?.h1_black} {section?.h1_purple}
              </h2>
            )}
          </div>
        )}

        <div className="flex md:pt-[35px] pt-[30px] flex-wrap">
          <div
            className={`${
              isDeleteRightData
                ? 'md:basis-4/4'
                : 'lg:basis-3/4 lg:pr-8 lg:mb-0 mb-5'
            }`}
          >
            {faqlist?.map((item, key) => (
              <div
                className={`shadow-[0px_0px_2px_rgba(0,_0,_0,_0.25)] ${
                  key === 0
                    ? 'rounded-[10px_10px_0px_0px] overflow-hidden'
                    : key === 3
                      ? 'rounded-[0px_0px_10px_10px]'
                      : ''
                }`}
                key={item?.id}
              >
                <div className={`open=${open === key} ${open === key}`}>
                  <button
                    onClick={() => handleOpen(key)}
                    className={`faq-question ${
                      key === 0
                        ? 'rounded-[10px_10px_0px_0px] overflow-hidden'
                        : key === 3
                          ? 'rounded-[0px_0px_10px_10px]'
                          : 'shadow-[0px_-1px_0px_rgba(0,_0,_0,_0.1)]'
                    }`}
                  >
                    <h3>{item?.question}</h3>
                  </button>
                  {item?.descriptionEditor ? (
                    <div
                      className="faq-answer"
                      dangerouslySetInnerHTML={createMarkup(
                        item?.descriptionEditor
                      )}
                    ></div>
                  ) : (
                    <div className="faq-answer ">{item?.answer}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
          {/* TODO pending card text */}
          {section?.view_faqs && (
            <Card
              className="bg-lightGray px-7 py-10"
              containerClass={` ${
                isDeleteRightData
                  ? 'hidden'
                  : 'lg:basis-1/4 basis-1/1 w-[100%] shadow-none lg:pl-8'
              } ${forCSS ? 'pt-0' : 'pt-5'}`}
              forCSS={true}
            >
              <h5 className="mb-3 font-semibold">Interested Fields</h5>
              <h5 className="text-primary mb-16 font-normal">
                {isFaq ? (
                  section?.view_faqs?.map((item, key) => (
                    <Link
                      href={`${item.link !== null && item?.link}`}
                      key={item?.id}
                      className="block"
                    >
                      {item?.text}
                    </Link>
                  ))
                ) : (
                  <Link
                    href="/services/cloud-managed-infrastructure-services"
                    className="block"
                  >
                    Cloud Managed Services
                  </Link>
                )}
                {isFaq
                  ? section?.viewFaq?.map((item, key) => (
                      <Link
                        href={`${item?.link}`}
                        key={item?.id}
                        className="block"
                      >
                        {item?.text}
                      </Link>
                    ))
                  : ''}
              </h5>
              <Link
                className="flex items-center cursor-pointer"
                href={'/about-us/faq'}
              >
                <h4 className="font-semibold text-[18px]">VIEW ALL FAQ</h4>
                <button
                  className="w-6 h-6 bg-primary text-white !rounded-full p-1 ml-5 flex items-center"
                  id="allFaq"
                  aria-label="View  frequently asked questions"
                >
                  <ArrowIcon />
                </button>
              </Link>
            </Card>
          )}

          {section?.viewFaq && (
            <Card
              className="bg-lightGray px-7 py-10"
              containerClass={` ${
                isDeleteRightData
                  ? 'hidden'
                  : 'lg:basis-1/4 basis-1/1 w-[100%] shadow-none lg:pl-8'
              } ${forCSS ? 'pt-0' : 'pt-5'}`}
              forCSS={true}
            >
              <h5 className="mb-3 font-semibold">Interested Fields</h5>
              <h5 className="text-primary mb-16 font-normal">
                {isFaq
                  ? section?.viewFaq?.map((item, key) => (
                      <Link
                        href={`${item?.link}`}
                        key={item?.id}
                        className="block"
                      >
                        {item?.text}
                      </Link>
                    ))
                  : ''}
              </h5>
              <Link
                className="flex items-center cursor-pointer"
                href={'/about-us/faq'}
              >
                <h4 className="font-semibold text-[18px]">VIEW ALL FAQ</h4>
                <button
                  className="w-6 h-6 bg-primary text-white !rounded-full p-1 ml-5 flex items-center"
                  id="allFaq"
                  aria-label="View  frequently asked questions"
                >
                  <ArrowIcon />
                </button>
              </Link>
            </Card>
          )}
        </div>
      </div>
    </Container>
  );
}
